{
  "type": "object",
  "name": "",
  "class": "g gtc-2 gr-4 gap",
  "definitions": [
    {
      "name": "object",
      "type": "fieldOk",
      "title": "Objekt",
      "autoLoad": true,
      "virtual": { "itemHeight": 53, "display": { "default": 9, "small": 4 } },
      "fieldOk": "objekt",
      "resultMapping": {
        "number": "objekt",
        "name": "bezeichnung"
      },
      "parameters": {
        "idktostamm_kunde": { "type": "valueReference", "path": "customer.id" }
      },
      "views": [
        {
          "type": "list",
          "title": "Daten",
          "definition": {
            "type": "object",
            "name": "",
            "class": "px-2 py-0 mt-0 truncate",
            "definitions": [
              {
                "type": "string",
                "class": "soft-overline mt-0 pt-0",
                "name": "objekt"
              },
              {
                "type": "string",
                "class": "text-base font-semibold truncate",
                "name": "bezeichnung"
              }
            ]
          }
        }
      ],
      "class": "gr-3 gc-1-2",
      "required": true
    },
    {
      "name": "zbewegungsarten",
      "type": "fieldOk",
      "placeholder": "Bewegungsart",
      "title": "Bewegungsart",
      "autoLoad": true,
      "array": true,
      "virtual": { "itemHeight": 53, "display": { "default": 9, "small": 4 } },
      "fieldOk": "zbewegungsart",
      "format": "{{zbewegungsart}} - {{bezeichnung}}",
      "resultMapping": {},
      "parameters": {
        "kzanzeigeapp": "J"
      },
      "views": [
        {
          "type": "list",
          "title": "Daten",
          "definition": {
            "type": "object",
            "name": "",
            "class": "px-2 py-0 mt-0 truncate",
            "definitions": [
              {
                "type": "string",
                "class": "soft-overline",
                "name": "zbewegungsart"
              },
              {
                "type": "string",
                "class": "text-base font-semibold truncate",
                "name": "bezeichnung"
              }
            ]
          }
        }
      ],
      "class": "gr-4 gc-1-2",
      "required": true
    },
    {
      "name": "from",
      "type": "date",
      "title": "Von",
      "control": "time",
      "class": "gr-1 gc-1",
      "required": true
    },
    {
      "name": "to",
      "type": "date",
      "title": "Bis",
      "control": "time",
      "class": "gr-1 gc-2",
      "required": true
    },
    {
      "name": "kzkurzepause",
      "type": "boolean",
      "title": "Kurze Pause",
      "control": "switch",
      "class": "gr-2 gc-1-2"
    },
    {
      "name": "description",
      "type": "string",
      "title": "Beschreibung",
      "control": "multiline",
      "class": "gr-5 gc-1-2"
    }
  ]
}
